import React, { useContext, useEffect, useState } from 'react'
import classes from './AddCartPopup.module.css'
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Box, IconButton } from '@mui/material';

import img from "../../../assets/bookPlaceHolder.png";
import Details from './Details';
import AuthContext from '../../Common/authContext';
import { useDispatch, useSelector } from 'react-redux';
import { addSelectedBook } from '../../redux/productSlice';
import axios from 'axios';
import { useParams } from 'react-router-dom';

// MUI Modal style
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 1300,
  bgcolor: "#fff",
  boxShadow: 24,
  borderRadius: "1em",
  overflow: "hidden",
  maxHeight: "90vh",
  overflowY: "auto",
};

const AddCartPopup = () => {
  const dispatch = useDispatch();
  const selectedVariants = useSelector((state) => state.products.selectedVariants);
  const selectedVariantProduct = useSelector((state) => state.products.selectedVariantProduct);
  const language = useSelector((state) => state.products.selectedLanguage[0].Language);
  const [selectedBook, setSelectedBook] = useState({});

  const authCtx = useContext(AuthContext)
    const fetchBook = async () => {
      try {
        if (authCtx.addtocartPopupId) {
          const response = await axios.get(`${import.meta.env.VITE_TESTING_API}/articles?id=${authCtx.addtocartPopupId}&ecom_type=${import.meta.env.VITE_ECOM_TYPE}`);
          const book = response.data;
          setSelectedBook(book);
        }
      } catch (error) {
        // console.error('Error fetching the book:', error);
      }
    };

    useEffect(()=>{
      if (authCtx.addtocartPopupOpen && authCtx.addtocartPopupId) {
        fetchBook()
      }
    },[authCtx.addtocartPopupOpen, authCtx.addtocartPopupId])

  // Get the main image to display
  const getMainImage = () => {
    const popupHasResolvedVariantProduct = selectedBook?.variant_product?.variants?.some(
      (row) => Number(row?.product?.id) === Number(selectedVariantProduct?.id)
    );

    if (popupHasResolvedVariantProduct && selectedVariantProduct?.articleimage?.length > 0) {
      return selectedVariantProduct.articleimage[0]?.link || img;
    }

    if (popupHasResolvedVariantProduct && selectedVariantProduct?.image) {
      return selectedVariantProduct.image;
    }

    if (selectedBook?.articleimage && selectedBook.articleimage.length > 0) {
      // Get all selected variant item IDs
      const selectedVariantItemIds = Object.values(selectedVariants || {})
        .map(variant => variant?.id)
        .filter(id => id);

      if (selectedVariantItemIds.length === 0) {
        // No variants selected, show first image
        return selectedBook.articleimage?.[0].link;
      }

      // Check if any selected variant has associated images
      const variantSpecificImages = selectedBook.articleimage.filter(image => 
        selectedVariantItemIds.includes(image.b_usr_article_variant_items_id)
      );

      if (variantSpecificImages.length > 0) {
        // Show first image for selected variants
        return variantSpecificImages[0].link;
      } else {
        // Selected variants have no specific images, show first image
        return selectedBook.articleimage?.[0].link;
      }
    }
    return img; // fallback to placeholder
  };
      
  const handleMouseMove = (e) => {
    const image = e.target;
    const boundingRect = image.getBoundingClientRect();
    
    const x = (e.clientX - boundingRect.left) / boundingRect.width;
    const y = (e.clientY - boundingRect.top) / boundingRect.height;

    image.style.transformOrigin = `${x * 100}% ${y * 100}%`;
  };

  const handleClose = () => {
    authCtx.setaddtocartPopupOpen(false);
  };

  // Don't render if no selected book
  if (!selectedBook && authCtx.addtocartPopupOpen) {
    return null;
  }
  // console.log('Selected Book:', selectedBook);

  return (
    <Modal
      open={authCtx.addtocartPopupOpen}
      onClose={handleClose}
      aria-labelledby="add-to-cart-popup-title"
      aria-describedby="add-to-cart-popup-description"
    >
      <Box sx={modalStyle}>
        {/* Close button */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'var(--primary-color)',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            zIndex: 1000,
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 1)',
            }
          }}
        >
          <CloseIcon />
        </IconButton>

        {selectedBook && (
          <div className={classes.bookDetails}>
            <div className={classes.bigContainer}>
              <div className={classes.booksContainer} >
                {/* Single image display */}
                <div className={classes.swiper}>
                  <div className={classes.imageContainer} style={{position:'relative',overflow:"hidden"}}>
                    {selectedBook.discount > 0 && (
                      <div className={classes.discountBtn}>-{selectedBook.discount}%</div>
                    )}
                    {selectedBook._qte_a_terme_calcule < 1 && (
                      <div style={{cursor:'pointer'}} className={classes.out_of_stock}>
                        <p>{selectedBook?.is_coming_soon ? (language === "eng" ? "Coming Soon" : "Bientôt Disponible") : (language === "eng" ? "OUT OF STOCK" : "HORS STOCK")}</p>
                      </div>
                    )}
                    <img loading="lazy" 
                      src={getMainImage()} srcSet={getMainImage()} 
                      alt="Book Cover" 
                      onMouseMove={handleMouseMove}
                      style={{width: '100%', height: 'auto'}}
                    />
                  </div>
                </div>
              </div>
              <Details/>
            </div>
          </div>
        )}
      </Box>
    </Modal>
  )
}

export default AddCartPopup

/* 
Usage Examples:

To open the AddCartPopup from any component that has access to AuthContext:

1. Import AuthContext:
   import AuthContext from '../Common/authContext';

2. Get the context:
   const authCtx = useContext(AuthContext);

3. Open the popup with a specific product ID:
   authCtx.setaddtocartPopupId(productId); // Set the product ID first
   authCtx.setaddtocartPopupOpen(true);    // Then open the popup

4. To close the popup:
   authCtx.setaddtocartPopupOpen(false);

Example in a product card component:
const handleQuickView = (productId) => {
  authCtx.setaddtocartPopupId(productId);
  authCtx.setaddtocartPopupOpen(true);
};

<button onClick={() => handleQuickView(product.id)}>
  Quick View
</button>
*/
